// Module
var code = "<div class=\"progress\"> <div class=\"progress-bar\" role=\"progressbar\" aria-valuemin=\"0\" aria-valuemax=\"100\" data-bind=\"style: { width: widthStyle },\r\n                    css: { 'bg-success': isUploaded, 'bg-primary' : isUploading },\r\n                    attr: { 'aria-label': label, 'aria-valuenow': progress }\"> </div> </div> ";
// Exports
export default code;